import {Component, Input} from '@angular/core';
import {OptionService} from "../option/option.service";
import {TranslateService} from "@ngx-translate/core";

@Component({
    selector: 'page-header',
    templateUrl: './page.header.html',
    providers: []
})
export class PageHeaderComponent {
    /**
     * The current step of the app
     */
    @Input() step: string;

    /**
     * Size of the viewport
     *
     * @type {any}
     */
    @Input() size: string = null;

    /**
     * force the header to be shown
     *
     * @type {boolean}
     */
    @Input() forceShow: boolean = null;

    /**
     * HOlds the type of the app that is currently shown
     * @type {any}
     */
    type: string = null;

    /**
     * The logo of the project/orga
     * @type {any}
     */
    logo: string = null;

    /**
     * should the logo be centered or not
     * @type {boolean}
     */
    logoCentered: boolean = false;

    /**
     * Image of the project
     * @type {any}
     */
    image: string = null;

    /**
     * Subheadline of the donation page
     * @type {boolean}
     */
    subheadline: boolean = null;

    /**
     * teasertext for the project
     * @type {string}
     */
    teaser: string = null;

    /**
     * Name of the project
     * @type {any}
     */
    projectName: string = null;

    /**
     * The constructor
     * @param optionService
     * @param translate
     */
    constructor(private optionService: OptionService, private translate: TranslateService) {}

    /**
     * Initialize the slider
     */
    public ngOnInit(): any {
        this.type = this.optionService.getType();
        this.logo = this.optionService.getOption("design_logo");
        if(this.optionService.getOption("has_hidden_logo") === true) {
            // hide the logo on the page
            this.logo = null;
        }
        this.logoCentered = this.optionService.getOption("design_logo_centered");
        this.image = this.optionService.getOption("image");
        this.projectName = this.optionService.getProjectName();

        // teaser and subheadline from translations
        let that = this;
        this.translate.get("pageheader.teaser").subscribe(data => {
            that.teaser = data != "pageheader.teaser"? data : null
        });
        this.translate.get("pageheader.subheadline").subscribe(data => {
            that.subheadline = data != "pageheader.subheadline"? data : null
        });
    }

    /**
     * Returns if the component should be visible or not
     * @returns {boolean}
     */
    showHeader(): boolean {
        if(this.forceShow !== null) {
            return this.forceShow;
        }

        // fallback to own decision
        return (this.type == "page" && this.step == "start" && (this.teaser != null || this.logo != null));
    }

    /**
     * Returns the text for the headline
     * @returns {any}
     */
    hasHeadline(): any {
        return this.translate.instant("headline.default").trim().length > 0;
    }
}
